export default __webpack_public_path__ + "static/media/crowd.13d70188.svg";